import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { SolicitudTutorDescuento, ISolicitudTutorDescuentoPagingRes, UseMutationsParams, AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';

const { get, post, put, remove } = erpApi();

///* tanSctack query

export const useGetSolicitudesTutorDescuento = (params?: GetSolicitudesTutorDescuentoParams) => {
  return useQuery({
    queryKey: ['solicitud-tutor-descuento', ...Object.values(params || {})],
    queryFn: async () => {
      return getSolicitudesTutorDescuentos(params);
    },
    refetchOnWindowFocus: false,
  });
};

export const useGetSolicitudTutorDescuentoById = (id: string) => {
  return useQuery({
    queryKey: ['solicitud-tutor-descuento', id],
    queryFn: async () => {
      return getSolicitudTutorDescuento(id);
    },
  });
};
export const useCreateSolicitudTutorDescuento = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createSolicitudTutorDescuento,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['solicitud-tutor-descuento'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Solicitud de tutor descuento creada correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const useUpdateSolicitudTutorDescuento = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: updateSolicitudTutorDescuento,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['solicitud-tutor-descuento'] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Solicitud de tutor descuento actualizada correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};
export const useRemoveSolicitudTutorDescuento = () => {
  const queryClient = useQueryClient();
  const setConfirmDialogIsOpen = useUiStore.getState().setConfirmDialogIsOpen;
  return useMutation({
    mutationFn: deleteSolicitudTutorDescuento,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['solicitud-tutor-descuento'] });
    },
    onSettled: () => {
      setConfirmDialogIsOpen(false);
    },
    onError: error => {
      handleAxiosError(error);
    },
  });
};
///* axios
export type GetSolicitudesTutorDescuentoParams = {
  page?: number;
  page_size?: number;
  nombre?: string;
  fecha_after?: string;
  fecha_before?: string;
  estado_solicitud?: string;
  estado_orden?: string;
  referencia?: string;
  codigo?:string;
  prospecto?:string;
};

export type CreateSolicitudesTutorDescuentoParams = Omit<SolicitudTutorDescuento, 'id_solicitud_tutor_descuento'> | Pick<SolicitudTutorDescuento, 'prospecto'>;
export type UpdateSolicitudesTutorDescuentoParams = {
  id: string;
  data: CreateSolicitudesTutorDescuentoParams;
};


export const getSolicitudesTutorDescuentos = async (params?: GetSolicitudesTutorDescuentoParams) => {
  const queryParams = getUrlParamsFetch({ ...params });

  return get<ISolicitudTutorDescuentoPagingRes>(
    `${urlBackend}api/v1/solicitudtutordescuento/?${queryParams}`,
    true
  );
};
export const getSolicitudTutorDescuento = async (id: string) => {
  try {
    return await get<SolicitudTutorDescuento>(`${urlBackend}api/v1/solicitudtutordescuento/${id}/`, true);
  }
  catch (error) {
    return handleAxiosError(error);
  }
};

export const createSolicitudTutorDescuento = async (data: CreateSolicitudesTutorDescuentoParams) => {
  const res = await post<SolicitudTutorDescuento>(`${urlBackend}api/v1/solicitudtutordescuento/`, data, true);
  return res;
};

export const updateSolicitudTutorDescuento = async ({ id, data }: UpdateSolicitudesTutorDescuentoParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<SolicitudTutorDescuento>(`${urlBackend}api/v1/solicitudtutordescuento/${id}/`, data, true);
  setAlert(true, res.message, res.status);
  return res;
};

export const deleteSolicitudTutorDescuento = async ({ id }: UpdateSolicitudesTutorDescuentoParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await remove<SolicitudTutorDescuento>(`${urlBackend}api/v1/solicitudtutordescuento/${id}/`, true);
  setAlert(true, res.message, res.status);
  return res;
};